import { useState } from "react";
import { X, Zap } from "lucide-react";

export const PromoBanner = () => {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;
  return (
    <div data-testid="top-promo-banner" className="relative z-[60] bg-volt text-forest-deep">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-4 py-2 text-center">
        <Zap className="h-3.5 w-3.5 shrink-0" strokeWidth={2.5} fill="currentColor" />
        <p className="font-mono text-[10px] font-bold tracking-[0.15em] uppercase sm:text-[11px]">
          Deal: buy any adult bike — kids helmet FREE
          <span className="mx-2 hidden sm:inline opacity-40">|</span>
          <span className="hidden sm:inline">Pre-order now, ride in 1–4 weeks</span>
        </p>
        <a
          data-testid="promo-banner-cta"
          href="#deals"
          onClick={(e) => {
            e.preventDefault();
            window.__lenis?.scrollTo("#deals", { offset: -80 });
          }}
          className="hidden shrink-0 border-b border-forest-deep/60 font-mono text-[10px] font-bold tracking-[0.15em] uppercase transition-opacity hover:opacity-70 md:inline"
        >
          See Deals
        </a>
        <button
          data-testid="promo-banner-dismiss"
          onClick={() => setDismissed(true)}
          className="absolute right-3 top-1/2 -translate-y-1/2 p-1 transition-opacity hover:opacity-60"
          aria-label="Dismiss banner"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
};
